<script lang="ts">
	// One line of copy with its «figures» set in mono, left to right, as the
	// design sets every Latin figure inside an Arabic sentence.

	import { parts } from './parts';

	interface Props {
		line: string;
	}

	let { line }: Props = $props();
</script>

{#each parts(line) as part, index (index)}{#if part.figure}<span class="figure" dir="ltr"
			>{part.text}</span
		>{:else}{part.text}{/if}{/each}

<style>
	.figure {
		font-family: var(--font-mono);
		font-weight: var(--weight-semibold);
		color: var(--text-strong);
	}
</style>
